import {
  ioDeleteEmailSupressed,
  ioGetEmailEventsList,
  ioGetEmailList,
  ioGetEmailSupressedList
} from '@/febos/servicios/api/emails.api';

export const getEmailsList = async ({ commit }, {
  query = {},
  sort = [
    {
      timestamp: {
        order: 'desc',
        missing: '_last'
      }
    }
  ],
  page = 1,
  itemPerPage = 10
}) => {
  try {
    commit('SET_LOADING', true);
    const from = (page - 1) * itemPerPage; // Calcular el valor de 'from'
    const size = itemPerPage; // Tamaño de página
    const { data: { data: { hits: { hits, total } } } } = await ioGetEmailList({
      body: {
        query,
        sort,
        from,
        size,

      }
    });
    commit('SET_EMAILS_LIST', {
      pages: Math.ceil(total.value / itemPerPage),
      itemPerPages: itemPerPage,
      emails: hits
    });
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getEmailSuppressedList = async ({ commit }, {
  query = {},
  sort = [
    {
      timestamp: {
        order: 'desc',
        missing: '_last'
      }
    }
  ],
  page = 1,
  itemPerPage = 10
}) => {
  try {
    commit('SET_LOADING_SUPPRESSION', true);
    const from = (page - 1) * itemPerPage; // Calcular el valor de 'from'
    const size = itemPerPage; // Tamaño de página
    const { data: { data: { hits: { hits, total } } } } = await ioGetEmailSupressedList({
      body: {
        query,
        sort,
        from,
        size,

      }
    });
    commit('SET_EMAILS_SUPPRESSION_LIST', {
      pages: Math.ceil(total.value / itemPerPage),
      itemPerPages: itemPerPage,
      list: hits
    });
  } finally {
    commit('SET_LOADING_SUPPRESSION', false);
  }
};

export const deleteEmailSuppressed = async ({ commit }, {
  id
}) => {
  try {
    commit('SET_LOADING_SUPPRESSION', true);
    await ioDeleteEmailSupressed({ id });
  } finally {
    commit('SET_LOADING_SUPPRESSION', false);
  }
};

export const setActualEmail = async ({ commit }, { email }) => {
  commit('SET_EMAIL', {
    email
  });
};
export const getEmailsEvents = async ({ commit }, { id = '', emailId = '' }) => {
  try {
    commit('SET_LOADING_EVENTOS', true);
    const data = await ioGetEmailEventsList({ params: { filtros: `messageId:${id},${emailId}`, orden: '-timestamp' } });
    commit('SET_EVENTOS', { eventos: data.data.documentos });
  } finally {
    commit('SET_LOADING_EVENTOS', false);
  }
};
export const clearEvents = async ({ commit }) => {
  commit('CLEAR_EVENTOS', true);
};

export const movePage = async ({ commit }, page) => {
  commit('SET_PAGE', { page });
};
export const changeItemPerPage = async ({ commit }, items) => {
  commit('SET_ITEM_PER_PAGE', { items, page: 1 });
};

export const movePageSuppressed = async ({ commit }, page) => {
  commit('SET_PAGE_SUPPRESSION', { page });
};
export const changeItemPerPageSuppressed = async ({ commit }, items) => {
  commit('SET_ITEM_PER_PAGE_SUPPRESSION', { items, page: 1 });
};
